export const MACROBOLSA_ROLE = 'Macrobolsa'
